
import { createSelector } from 'reselect';
import { householdMemberTools } from '../../utils/tools/householdMemberTools';
import { APPLICATION_STATUSES } from '../../constants/common/applicationStatusesAndModes';
import { dataActionTypes } from '../../constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {
    mockData: true,
    runMode: null,
    taxHousehold: {
        bloodRelationship: [],
        householdMember: []
    }
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case dataActionTypes.CHANGE_DATA:
            return action.newState;
        case dataActionTypes.SET_SESSION_INITIAL_DATA:
        case dataActionTypes.SET_DATA:
            return action.data;
        case dataActionTypes.UPDATE_SSNS:
            return {
                ...state,
                taxHousehold: {
                    ...state.taxHousehold,
                    householdMember: state.taxHousehold.householdMember.map(hhm => {
                        const {
                            applicantGuid
                        } = hhm;

                        const matchedSSN = action.ssns.find(ssn => ssn.applicantGuid === applicantGuid);

                        if(!matchedSSN) {
                            console.error(`SSN for applicant with GUID ${applicantGuid} is not found amid received SSNs`);
                            return hhm;
                        } else {
                            return {
                                ...hhm,
                                socialSecurityCard: {
                                    ...hhm.socialSecurityCard,
                                    socialSecurityNumber: matchedSSN.ssn
                                }
                            };
                        }
                    })
                }
            };
        case dataActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};

// Selectors

export const getApplicationId = state => state.ssapApplicationId;
export const getCaseNumber = state => state.applicationGuid;
export const getCoverageYear = state => state.coverageYear;
export const selectPrimaryTaxFilerPersonId = state => state.taxHousehold.primaryTaxFilerPersonId;
export const selectHouseholdMembers = state => state.taxHousehold.householdMember;

export const selectPrimaryTaxFiler = createSelector(
    selectHouseholdMembers,
    selectPrimaryTaxFilerPersonId,
    (householdMembers, primaryTaxFilerPersonId) => {
        return primaryTaxFilerPersonId
            ? householdMembers.find(hhm => hhm.personId === primaryTaxFilerPersonId)
            : null;
    }
);

export const selectBloodRelationships = state => state.taxHousehold.bloodRelationship;
export const selectMaxAchievedPage = state => state.maxAchievedPage;
export const getApplicantGuids = state => state.taxHousehold.householdMember.map(hhm => hhm.applicantGuid);
export const selectCoverageIndicators = state => state.taxHousehold.householdMember.map(hhm => hhm.applyingForCoverageIndicator);
export const selectCurrentlyPregnantIndicators = state => state.taxHousehold.householdMember.map(hhm => hhm.specialCircumstances.currentlyPregnant);
export const selectRunMode = state => state.runMode;

export const selectIfRenewalFlow = createSelector(
    selectRunMode,
    runMode => runMode === '4'
);

export const selectIfSsapOpenInReviewMode = state => state.applicationStatus !== APPLICATION_STATUSES.OPEN
    && state.applicationStatus !== APPLICATION_STATUSES.UNCLAIMED;

export const selectAddressVisibilityDueToGeneralDelivery = createSelector(
    selectHouseholdMembers,
    householdMembers => {
        const {
            applicantGuid: primaryContactGuid,
            noHomeAddressIndicator
        } = householdMemberTools.getPrimaryContact(householdMembers);
        return householdMembers.reduce((result, hhm) => {
            const {
                applicantGuid,
                livesAtOtherAddressIndicator
            } = hhm;
            if (applicantGuid === primaryContactGuid && noHomeAddressIndicator === true) {
                return {
                    ...result,
                    [ applicantGuid ]: true
                };
            } else if (applicantGuid !== primaryContactGuid && noHomeAddressIndicator === true && !livesAtOtherAddressIndicator) {
                return {
                    ...result,
                    [ applicantGuid ]: true
                };
            } else {
                return {
                    ...result,
                    [ applicantGuid ]: false
                };
            }
        },
        { }
        );
    }
);